'use client';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { useProductTracking } from '@/modules/product/hooks/useProductTracking.ts';
import { type ProductBrandAttribute } from '@/modules/product/types.ts';

type Props = {
  brand: ProductBrandAttribute;
  productId?: number;
};

export function BrandNameLink({ productId, brand }: Props) {
  const t = useTranslations('product');
  const { sendProductInteractionActionATEvent } = useProductTracking();

  function handleBrandNameClick() {
    if (productId) {
      sendProductInteractionActionATEvent(productId, 'ProductBrand', {
        brand: brand.name,
      });
    }
  }

  return (
    <ExtendedLink
      href={`/brands/${brand.id}/`}
      onClick={handleBrandNameClick}
      aria-label={t('BrandAria', { brand: brand.name })}
      className={styles.linkAttribute}
    >
      <Caption variant="lg-regular" colour="base" className={styles.attribute}>
        {brand.name}
      </Caption>
    </ExtendedLink>
  );
}
